export const IconStorage = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M2 5.063C2 4.475 2.478 4 3.07 4h2.44c.92 0 1.74.584 2.03 1.454l3.082 9.171c1.007.017 1.9.495 2.476 1.229l6.762-2.238a1.074 1.074 0 0 1 1.355.67 1.063 1.063 0 0 1-.676 1.345l-6.762 2.238C13.747 19.602 12.322 21 10.565 21c-1.773 0-3.212-1.428-3.212-3.187a3.18 3.18 0 0 1 1.238-2.517L5.51 6.125H3.07C2.479 6.125 2 5.65 2 5.063m8.19 3.403a1.06 1.06 0 0 1 .686-1.338l1.53-.492.662 2.022 2.037-.657-.665-2.022 1.529-.492a1.07 1.07 0 0 1 1.348.681l1.653 5.054a1.06 1.06 0 0 1-.686 1.338l-5.092 1.64a1.07 1.07 0 0 1-1.349-.68z" />
    </svg>
  );
};
